import { Wizard } from '../../../components/Wizard/Wizard';
import { ChooseCountryWizardStepRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryWizardStepRedesign';
import { EmailVerificationRedesign } from '../redesign-components/EmailVerificationRedesign/EmailVerificationRedesign';
import { LogInOptionsRedesign } from '../redesign-components/LogInOptionsRedesign/LogInOptionsRedesign';
import { WelcomeBonusRedesign } from '../redesign-components/WelcomeBonusRedesign/WelcomeBonusRedesign';

import { authWizardWrapperStyle } from './constants';
import styles from './RedesignWizard.module.scss';

const STEPS_REDESIGN = [
  LogInOptionsRedesign,
  EmailVerificationRedesign,
  ChooseCountryWizardStepRedesign,
  WelcomeBonusRedesign,
];

export default function LogInWizard() {
  return (
    <Wizard
      classNameSteps={styles.redesignFlowSteps}
      classNameStepWrapper={styles.redesignFlowStepWrapper}
      steps={STEPS_REDESIGN}
      wrapperStyle={authWizardWrapperStyle}
    />
  );
}
